module.exports = __webpack_public_path__ + "img/ynjt2.206820f2.jpg";